<!-- not-found.component.html -->

<div class="nf">

  <!-- Animated background grid -->
  <div class="nf__bg">
    <div class="nf__bg-grid"></div>
  </div>

  <div class="nf__card">

    <!-- Logo -->
    <div class="nf__logo-wrap">
      <img
        src="assets/images/fieldlogo.png"
        alt="FieldOps"
        class="nf__logo"
        onerror="this.style.display='none'; this.nextElementSibling.style.display='flex'"
      />
      <div class="nf__logo-fallback" style="display:none">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
          <rect x="2" y="8" width="20" height="13" rx="2.5" fill="white" fill-opacity=".9"/>
          <path d="M16 8V6C16 4.9 15.1 4 14 4H10C8.9 4 8 4.9 8 6V8" fill="white" fill-opacity=".6"/>
          <circle cx="17" cy="6" r="4" fill="#2BB0A6"/>
          <path d="M15.5 6L16.8 7.3L18.8 5" stroke="white" stroke-width="1.3"
                stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>

    <!-- 404 number -->
    <div class="nf__number">
      <span class="nf__four nf__four--left">4</span>
      <div class="nf__zero">
        <svg class="nf__pin-svg" viewBox="0 0 80 80" fill="none">
          <circle cx="40" cy="35" r="28" stroke="#E4E7EC" stroke-width="6"/>
          <circle cx="40" cy="35" r="28" stroke="url(#pinGrad)" stroke-width="6"
                  stroke-linecap="round" stroke-dasharray="176" stroke-dashoffset="44"/>
          <circle cx="40" cy="35" r="12" fill="url(#pinGrad)"/>
          <path d="M40 63C40 63 40 72 40 75" stroke="#2BB0A6" stroke-width="5"
                stroke-linecap="round"/>
          <defs>
            <linearGradient id="pinGrad" x1="12" y1="7" x2="68" y2="63" gradientUnits="userSpaceOnUse">
              <stop stop-color="#2BB0A6"/>
              <stop offset="1" stop-color="#1F3A5F"/>
            </linearGradient>
          </defs>
        </svg>
      </div>
      <span class="nf__four nf__four--right">4</span>
    </div>

    <!-- Message -->
    <h1 class="nf__title">Page Not Found</h1>
    <p class="nf__desc">
      Looks like this location isn't on the map.<br/>
      The page you're looking for doesn't exist or has been moved.
    </p>

    <!-- Actions -->
    <div class="nf__actions">
      <a routerLink="/dashboard" class="nf__btn nf__btn--primary">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
          <rect x="3" y="3" width="7" height="7" rx="1.5" stroke="currentColor" stroke-width="1.8"/>
          <rect x="14" y="3" width="7" height="7" rx="1.5" stroke="currentColor" stroke-width="1.8"/>
          <rect x="3" y="14" width="7" height="7" rx="1.5" stroke="currentColor" stroke-width="1.8"/>
          <rect x="14" y="14" width="7" height="7" rx="1.5" stroke="currentColor" stroke-width="1.8"/>
        </svg>
        Back to Dashboard
      </a>
      <button class="nf__btn nf__btn--ghost" (click)="goBack()">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
          <path d="M19 12H5M5 12L12 19M5 12L12 5"
                stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        Go Back
      </button>
    </div>

    <!-- Helpful links -->
    <div class="nf__links">
      <span class="nf__links-label">Or go to:</span>
      <a routerLink="/jobs" class="nf__link">Jobs</a>
      <span class="nf__links-sep">·</span>
      <a routerLink="/workers" class="nf__link">Workers</a>
      <span class="nf__links-sep">·</span>
      <a routerLink="/live-map" class="nf__link">Live Map</a>
      <span class="nf__links-sep">·</span>
      <a routerLink="/reports" class="nf__link">Reports</a>
    </div>

  </div>

</div>